import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { ChevronDown } from "lucide-react";
interface FAQItem {
  question: string;
  answer: string;
}
const faqItems: FAQItem[] = [{
  question: "Hva er forskjellen på kredittkort og debetkort?",
  answer: "Et kredittkort lar deg låne penger fra banken når du handler, og du betaler tilbake senere – enten hele beløpet eller i avdrag. Et debetkort trekker pengene direkte fra kontoen din når du bruker det. Kredittkort gir ofte ekstra fordeler som cashback, reiseforsikring og bonuspoeng."
}, {
  question: "Hva betyr rentefri periode på kredittkort?",
  answer: "Rentefri periode er tiden du har til å betale ned kredittkortet uten å betale renter. Denne perioden varierer fra 30 til 60 dager avhengig av kortet. Betaler du hele beløpet innen fristen, slipper du rentekostnader. Det gjør kredittkort gratis å bruke hvis du er disiplinert."
}, {
  question: "Hvordan velge beste kredittkort for meg?",
  answer: "Det beste kredittkortet avhenger av dine behov. Reiser du mye? Velg et kort med reiseforsikring og bonuspoeng. Handler du ofte på nett? Se etter cashback-kort. Trenger du fleksibilitet? Prioriter lang rentefri periode og lav rente. Bruk quizen vår for personlig anbefaling."
}, {
  question: "Kan jeg ha flere kredittkort?",
  answer: "Ja, du kan ha flere kredittkort. Mange velger å ha ett kort for daglige kjøp med cashback, og ett for reiser med god forsikringsdekning. Husk at total kredittramme påvirker låneevnen din, og at det er viktig å ha kontroll på utgiftene på tvers av kortene."
}, {
  question: "Hva skjer om jeg bare betaler minimumsbeløpet?",
  answer: "Hvis du bare betaler minimumsbeløpet, unngår du purring og inkasso, men du begynner å betale renter på restbeløpet. Over tid kan dette bli dyrt. For eksempel: Med 20 % rente og kun minimumsbetaling kan det ta mange år å nedbetale selv moderate beløp. Vi anbefaler å betale hele beløpet når mulig."
}, {
  question: "Er det gratis å søke om kredittkort?",
  answer: "Ja, det er helt gratis og uforpliktende å søke om kredittkort. Du binder deg ikke til noe ved å søke, og kan sammenligne tilbudene før du bestemmer deg. Gjennom oss kan du sende én søknad til flere banker og få oversikt over dine muligheter."
}];
export const FAQ = () => {
  return <section className="w-full bg-card">
      <div className="container mx-auto px-4 py-12 md:py-16 max-w-[1000px]">
        <h2 className="text-foreground mb-8 text-center font-normal text-3xl">
          Ofte stilte spørsmål om kredittkort
        </h2>
        
        <Accordion type="single" collapsible className="w-full">
          {faqItems.map((item, index) => <AccordionItem key={index} value={`item-${index}`} className="border-0 py-1">
              <AccordionTrigger className="text-left text-[20px] font-normal text-foreground hover:no-underline py-4 [&[data-state=open]>svg]:rotate-180 [&>svg]:text-primary [&>svg]:transition-transform">
                {item.question}
              </AccordionTrigger>
              <AccordionContent className="text-[16px] text-foreground leading-relaxed pb-4">
                {item.answer}
              </AccordionContent>
            </AccordionItem>)}
        </Accordion>
      </div>
    </section>;
};